import React from 'react';

const WhatsAppButton = () => (
  <>
    {/* Floating Request Quote Button - Mobile Only */}
    <a
      href="#lead-capture"
      className="fixed bottom-6 left-6 z-50 md:hidden bg-accent text-white rounded-full shadow-soft p-4 flex items-center justify-center hover:bg-primary transition"
      aria-label="Request a Quote"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
      </svg>
    </a>
    
    {/* WhatsApp Button */}
    <a
      href="https://wa.me/917996005799"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 bg-accent text-white rounded-full shadow-soft p-4 flex items-center justify-center hover:bg-primary transition"
      aria-label="Chat on WhatsApp"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" viewBox="0 0 24 24">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.472-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.149-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.372-.01-.571-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.1 3.2 5.077 4.366.709.306 1.262.489 1.694.626.712.227 1.36.195 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.288.173-1.413-.074-.124-.272-.198-.57-.347zm-5.421 7.617h-.001a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.999-3.648-.235-.374A9.86 9.86 0 012.1 12.045C2.111 6.479 6.58 2.001 12.153 2c2.652 0 5.151 1.037 7.027 2.917a9.825 9.825 0 012.924 7.012c-.013 5.572-4.482 10.05-10.053 10.05zm8.413-18.263A11.815 11.815 0 0012.153 0C5.453 0 .109 5.344.1 12.038c0 2.124.555 4.199 1.607 6.032L0 24l6.064-1.615a11.888 11.888 0 005.006 1.184h.005c6.699 0 12.144-5.344 12.153-11.938a11.82 11.82 0 00-3.343-8.495z"/>
      </svg>
    </a>
  </>
);

export default WhatsAppButton; 